import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    label: {
        color: theme.colors.gray[7],
        fontSize: rem(14),
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
    },
    option: {
        color: theme.colors.gray[7],
        fontSize: rem(14),
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
    },
    errors: {
        color: theme.colors.gray[7],
        lineHeight: 1.2,
        fontSize: rem(14),
        marginTop: "-10px",
    },
    container: {
        display: "flex",
        gap: rem(6),
    },
}))
